import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useUser } from "../hooks/use-user";
import { UserRole } from "../lib/enums";

const AdminRoute: React.FC = () => {
  const { user } = useUser();

  if (user?.role !== UserRole.ADMIN) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default AdminRoute;
